export type {
  Context,
  Attributes,
  Polyfills,
  CacheSettings,
  FeatureApiResponse,
  LoadFeaturesOptions,
  RefreshFeaturesOptions,
  FeatureDefinitions,
  FeatureDefinition,
  FeatureRule,
  FeatureResult,
  FeatureResultSource,
  Experiment,
  Result,
  ExperimentOverride,
  ExperimentStatus,
  JSONValue,
  SubscriptionFunction,
  LocalStorageCompat,
  WidenPrimitives,
  VariationMeta,
  Filter,
  VariationRange,
  UrlTarget,
  UrlTargetType,
} from "./types/growthbook";

export type { ConditionInterface } from "./types/mongrule";

export { setPolyfills, clearCache, configureCache } from "./feature-repository";

export { GrowthBook } from "./GrowthBook";

export { isURLTargeted } from "./util";
